/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![LinkIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB10lEQVR4nOWVv0scURDHFy9gI4QYf/8FlrGxvXbx9s3MHo4z669S/A+0u9rGQqzSp1EhKVSwEEkUCyGCQoIeKgrW/glG3u6ernd7e56LhWRgm53Zz/e977zZ5zj/XRSLxQ8AE7OGZAtIrwClCiQbiIHJDff9qUFAOQTSf6kP6g9m7noVHECHDOlZBJJrQzKHOPmFKBg1KAtAchcJyfdccENy7HlBT32NVw6GayKGxGtPAGNbUH8zc3fTOpLFWGC9LQGD8hVQt7PgNqxdsYVV5y0CQEfCHaBetCocApITQNmtz1n/AXUHSJYaviOdjwRk84UN1V8NcCsc9WMnmSOa+QykNzbnocykwseYB56O4vOGusy9j3CSk+RJKpUmP9n62P9DZi40wCuVSgegHuSEV60D6db4wrWiJJyZC4+AOnj4Hcp+3NjzpvCoUNdCCOh48r3rup1AemtF0gbMkO6Fu8uCR4VyHK7EaH99znXdTvuTc/JEbVp9f7ovq46Zu60tduVtCRiU1eiIBZQN17AfhuT0NVN4b0j/MPPHTDi2aGjTXZAsx4C/hqRs7bJ3AKIIoFzmgserLMQi92kXiiH9aQWdvBHZJSvh4KEeGdJvAOrbYcwNf3fxACWiGo/3tJrIAAAAAElFTkSuQmCC)
 */
export const LinkIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.32 14.72a1 1 0 0 1 0-1.41l2.51-2.51a3.98 3.98 0 0 0-5.62-5.63l-2.52 2.51a1 1 0 0 1-1.41-1.41l2.52-2.52a5.98 5.98 0 0 1 8.45 8.46l-2.52 2.51a1 1 0 0 1-1.41 0ZM7.68 9.29a1 1 0 0 1 0 1.41l-2.52 2.51a3.98 3.98 0 1 0 5.63 5.63l2.51-2.52a1 1 0 0 1 1.42 1.42l-2.52 2.51a5.98 5.98 0 0 1-8.45-8.45l2.51-2.51a1 1 0 0 1 1.42 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M14.7 10.7a1 1 0 0 0-1.4-1.4l-4 4a1 1 0 1 0 1.4 1.4l4-4Z"
        className={colorClass}
      />
    </svg>
  );
};
